// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"245":"86eeec75","682":"86eeec75","870":"86eeec75"}[chunkId] + ".chunk.css";
};